import Spinner from "react-bootstrap/Spinner";
function Loading(props) {
  return (
    <div className={props.containerDims}>
      <Spinner
        className={`mr-2 ${props.spinnerDims}`}
        animation="border"
        variant="primary"
        size="xl"
      />
    </div>
  );
}
export default Loading;
